import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import { LOCATION_STATUS } from '../../../darkmatter/GeoClosestLocation';

export default class SortByDistanceButton extends React.Component {
  renderSortingCompleteStatus() {
    return (
      <p className="locations-filter-geostate-unavailable">
        <Icon name="location arrow" />
        Distance sorting complete
      </p>
    );
  }

  renderUserLocationUnavailableStatus() {
    return (
      <p className="locations-filter-geostate-unavailable">
        <Icon name="location arrow" />
        Location unavailable
      </p>
    );
  }

  renderLocationIdleStatus() {
    const { loading, onSort } = this.props;

    return (
      <Button
        onClick={onSort}
        content="Sort by distance"
        icon="location arrow"
        basic
        loading={loading}
      />
    );
  }

  render() {
    const { locationSortingStatus } = this.props;

    let SortButton = null;
    if (locationSortingStatus === LOCATION_STATUS.LOCATION_UNAVAILABLE) {
      SortButton = this.renderUserLocationUnavailableStatus();
    } else if (locationSortingStatus === LOCATION_STATUS.FINISHED) {
      SortButton = this.renderSortingCompleteStatus();
    } else {
      SortButton = this.renderLocationIdleStatus();
    }

    return <div className="locations-filter-geostate-label">{SortButton}</div>;
  }
}
